(async () => {
    const { Core } = await importModule('Core');

    customElements.define('request-pricing', class extends Core {

        elements = {
            frontSize: '[data-front-size]',
            selectedOption: '[data-selected-option]'
        }

        subscriptions = {
            'variant:change': '_onVariantChange'
        }

        render() {
            if (this._ready) return;
            this._ready = true;

            const json = this.querySelector('[data-variants]');
            try {
                this.variants = JSON.parse(json?.textContent || '{}');
            } catch (e) {
                this.variants = {};
            }

            // Only track the selected variant when the block's "use selected variant" setting is on
            if (this.hasAttribute('data-use-variant')) this.subscribe('variant:change');
        }

        _onVariantChange(data) {
            const title = this.variants[data?.variantId];
            if (!title) return;
            if (this.$selectedOption) this.$selectedOption.value = title === 'Default Title' ? '' : title;
            // Only pre-fill when the variant title is a size, not an option combo like "5-Lug / Brushed Gold"
            if (title === 'Default Title' || title.includes(' / ')) return;
            // Don't overwrite a size the customer typed themselves
            const untouched = !this._lastAuto
                ? this.$frontSize.value === ''
                : this.$frontSize.value === this._lastAuto;
            if (untouched) this.$frontSize.value = title;
            this._lastAuto = title;
        }
    })
})();
